import React from "react";
import {
  INVEST_PDF_SEKCIE,
} from "../../utils/investPonukaPdfData";

export default function InvesticneExportPonukaPdfModal({
  jeOtvoreny,
  nazovSuboruPdf,
  setNazovSuboruPdf,
  menoKlientaPdf,
  setMenoKlientaPdf,
  pdfSekcie,
  setPdfSekcie,
  dostupnostSekcii,
  generujeSa,
  chyba,
  onZavriet,
  onPotvrdit,
}) {
  const nazovInputRef =
    React.useRef(null);

  React.useEffect(() => {
    if (!jeOtvoreny) {
      return undefined;
    }

    const povodnyOverflow =
      document.body.style.overflow;

    document.body.style.overflow =
      "hidden";

    const focusTimer = window.setTimeout(
      () =>
        nazovInputRef.current?.focus(),
      0
    );

    const zavriKlavesou = (event) => {
      if (
        event.key === "Escape" &&
        !generujeSa
      ) {
        onZavriet();
      }
    };

    window.addEventListener(
      "keydown",
      zavriKlavesou
    );

    return () => {
      window.clearTimeout(focusTimer);
      window.removeEventListener(
        "keydown",
        zavriKlavesou
      );
      document.body.style.overflow =
        povodnyOverflow;
    };
  }, [
    jeOtvoreny,
    generujeSa,
    onZavriet,
  ]);

  if (!jeOtvoreny) {
    return null;
  }

  const zavriModal = () => {
    if (!generujeSa) {
      onZavriet();
    }
  };

  const prepniSekciu = (sekcia) => {
    if (sekcia.povinna) {
      return;
    }

    setPdfSekcie((povodneSekcie) => ({
      ...povodneSekcie,
      [sekcia.kluc]: !Boolean(
        povodneSekcie?.[sekcia.kluc]
      ),
    }));
  };

  return (
    <div
      className="pdf-modal-overlay"
      onClick={zavriModal}
    >
      <div
        className="pdf-modal pdf-modal--investicna"
        role="dialog"
        aria-modal="true"
        aria-labelledby="invest-pdf-modal-title"
        onClick={(event) =>
          event.stopPropagation()
        }
      >
        <div className="pdf-modal__header">
          <h2
            id="invest-pdf-modal-title"
            className="pdf-modal__title"
          >
            Uložiť investičnú ponuku do PDF
          </h2>
        </div>

        <div className="pdf-modal__body">
          <div className="pdf-modal__grid">
            <div className="pdf-modal__field">
              <label
                className="pdf-modal__label"
                htmlFor="invest-pdf-nazov-suboru"
              >
                Názov súboru
              </label>

              <input
                ref={nazovInputRef}
                id="invest-pdf-nazov-suboru"
                className="pdf-modal__input"
                type="text"
                value={nazovSuboruPdf}
                disabled={generujeSa}
                onChange={(event) =>
                  setNazovSuboruPdf(
                    event.target.value
                  )
                }
                placeholder="Ponuka_investicie"
              />
            </div>

            <div className="pdf-modal__field">
              <label
                className="pdf-modal__label"
                htmlFor="invest-pdf-meno-klienta"
              >
                Meno klienta
              </label>

              <input
                id="invest-pdf-meno-klienta"
                className="pdf-modal__input"
                type="text"
                value={menoKlientaPdf}
                disabled={generujeSa}
                onChange={(event) =>
                  setMenoKlientaPdf(
                    event.target.value
                  )
                }
                placeholder="Meno klienta"
              />
            </div>
          </div>

          <div className="pdf-modal__sekcie">
            <div className="pdf-modal__sekcie-title">
              Sekcie v PDF
            </div>

            <div className="pdf-modal__checkbox-grid">
              {INVEST_PDF_SEKCIE.map(
                (sekcia) => {
                  const dostupna =
                    !sekcia.dostupnostKluc ||
                    Boolean(
                      dostupnostSekcii?.[
                        sekcia.dostupnostKluc
                      ]
                    );

                  if (!dostupna) {
                    return null;
                  }

                  const zamknuta =
                    Boolean(sekcia.povinna);

                  return (
                    <label
                      className={`pdf-modal__checkbox ${
                        zamknuta
                          ? "is-locked"
                          : ""
                      }`}
                      key={sekcia.kluc}
                    >
                      <input
                        type="checkbox"
                        checked={Boolean(
                          pdfSekcie?.[
                            sekcia.kluc
                          ]
                        )}
                        disabled={
                          zamknuta ||
                          generujeSa
                        }
                        onChange={() =>
                          prepniSekciu(
                            sekcia
                          )
                        }
                      />

                      <span>
                        {sekcia.label}
                      </span>
                    </label>
                  );
                }
              )}
            </div>
          </div>

          {chyba && (
            <div
              className="pdf-modal__error"
              role="alert"
            >
              {chyba}
            </div>
          )}
        </div>

        <div className="pdf-modal__footer">
          <button
            type="button"
            className="pdf-modal__btn pdf-modal__btn--secondary"
            disabled={generujeSa}
            onClick={zavriModal}
          >
            Zavrieť
          </button>

          <button
            type="button"
            className="pdf-modal__btn pdf-modal__btn--primary"
            disabled={generujeSa}
            onClick={onPotvrdit}
          >
            {generujeSa
              ? "Generujem PDF…"
              : "Vygenerovať PDF"}
          </button>
        </div>
      </div>
    </div>
  );
}